/**
 * created by hezq on 2019-10-24
 *
 * description： 配置文件
 *
 */

const config = {
	// 项目名称
	PROJECT_NAME: 'spweb',
	// 域名前缀标识
	PLAT: 'Market',
	// 系统id
	SUB_SYSTEM: 'S00000',
	// 平台编码，由基础服务配置产生
	SSID: 'M11190',
	// BS基础平台
	BASE_PATH: '//bsapi.norincogroup-ebuy.com/baseInvoker',
	// 供应商评价地址
	MS_SP_PATH: '//msapi.norincogroup-ebuy.com/attweb',
	// 权限服务地址
	MS_AUTH_PATH: '//msapi.norincogroup-ebuy.com/authweb',
	// 会员微服务
	API_MB: '//msapi.norincogroup-ebuy.com/menberweb',
	// 文件服务地址
	MS_FILE_PATH: '//msapi.norincogroup-ebuy.com/filemweb',
	// 资源服务地址
	MS_DOC_PATH: '//resource.norincogroup-ebuy.com',
	// 2.0资源服务地址
	DOC_PATH: '//file.norincogroup-ebuy.com',
	// 基础前台
	BS_PATH: '//bs.norincogroup-ebuy.com',
	// domain配置
	DOMAIN: '.norincogroup-ebuy.com',
	// 服务端接口报错默认提示
	MSG_SERVER_ERROR: '服务内部错误',
	// 未登录或登录失效默认提示
	MSG_NO_LOGIN: '未登录或登录失效，请重新登录',
	// 请求接口无权限默认提示
	MSG_NO_AUTH: '请求无权限',
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/libs/config.js